"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalEnv = optionalEnv;
/**
 * Node-only env lookup. Cloudflare Workers do not define `process` unless
 * `nodejs_compat` is enabled, and `typeof` is the check that does not throw.
 */
function optionalEnv(name) {
    if (typeof process === "undefined")
        return undefined;
    return process.env[name];
}
//# sourceMappingURL=optionalEnv.js.map